import axiosInstance from '../axios/axios';

export const sendMessageAsync = async (message: { body: unknown }): Promise<void> => {
  await axiosInstance.post('api/start-processing', message.body);
};
